/**
 * API endpoint configuration (build‑time only)
 * Single API URL for all routes (auth + drafts served by the same Lambda)
 */

const apiUrl = process.env.REACT_APP_API_URL;

if (!apiUrl) {
    throw new Error('REACT_APP_API_URL is required at build time');
}

export const API_ENDPOINTS = {
    AUTH: apiUrl,
    DRAFTS: apiUrl,
};

export const getApiEndpoint = (service: keyof typeof API_ENDPOINTS, path: string): string => {
    return `${API_ENDPOINTS[service]}${path}`;
};
